var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"covid-row d-sm-none"},[_vm._v(" India Covid Summery"),_c('br'),_vm._v(" "+_vm._s(_vm._f("comma")(_vm.covid_data.TotalDeaths))+" Deaths out of "+_vm._s(_vm._f("comma")(_vm.covid_data.TotalConfirmed))+" Total Cases. ")])}
var staticRenderFns = []

export { render, staticRenderFns }